// eslint-disable-next-line import/no-anonymous-default-export
export default {
  home: {
    title: "Chào mừng tới Viblo!",
    content: "Bắt đầu một bài viết nào",
  },
  all: "Tất cả",
  applyFor: "Ứng tuyển vị trí",
  apply: "Ứng tuyển",
  jobDetail: "Xem chi tiết",
  searchResult: "kết quả tìm kiếm",
  relatedJobs: "Công việc liên quan",
  benefits: "Phúc lợi",
  assignTo: "Người phụ trách",
  noInfo: "Không có thông tin",
  generalInfo: "Thông tin chung",
  hotJob: "Gấp",
  filterByCriteria: "Chọn lọc theo tiêu chí",
  jobName: "Tên công việc",
  jobLocation: "Nơi làm việc",
  salary: "Thoả thuận",
  job: "Vị trí",
  jobListTitle: "Vị trí tuyển dụng",
  recruitments: "Phương án tuyển dụng",
  jobInactive: "Việc làm này đã hết hạn hoặc không còn tồn tại.",
  campaigns: "Chiến dịch",
  jobShare: {
    copied: "Đã sao chép liên kết"
  },
  modalApplyNow: {
    searchCode: "Mã số tra cứu ứng viên vủa bạn là:",
    searchCodeBody: "Vui lòng lưu lại để không đánh mất mã tra cứu",
    research: "Tra cứu",
    here: "tại đây",
    researchBody: "để theo dõi quá trình ứng tuyển",
  },
  applyNow: {
    success: "Nộp đơn thành công!",
    successBody: "Cảm ơn bạn đã quan tâm đến công ty.",
    fail: "Thất bại!",
    failBody: "Có lỗi xảy ra trong quá trình ứng tuyển.",
    photoNotice: "Kéo ảnh hoặc click để chọn file",
    errorServerMessage: "Đã xảy ra lỗi khi nộp đơn ứng tuyển nhanh",
    successBodyNoCode:
      "Cảm ơn bạn đã nộp đơn. Chúng tôi đã nhận được CV của bạn và thực sự đánh giá cao sự quan tâm của bạn đối với vị trí này. Nếu hồ sơ của bạn phù hợp với yêu cầu của chúng tôi, nhóm của chúng tôi sẽ liên hệ với bạn qua điện thoại hoặc email trong vòng 1-3 tuần.",
  },
  formLabel: {
    name: "Họ và tên",
    email: "Email",
    phone: "Số điện thoại",
    gender: "Giới tính",
    dob: "Ngày sinh",
  },
  formValidate: {
    name: "Tên của bạn ít nhất phải 2 kí tự",
    dob: "Không được để trống ngày sinh",
    gender: "Không được để trống giới tính",
    phoneAndEmail: "Không đúng định dạng",
    notRequire: "Không bắt buộc",
  },
  research: {
    search: "Tìm kiếm",
  },
  formDynamic: {
    file: {
      errorSize: "File không được lớn hơn",
      errorType: "Loại file không hợp lệ",
      errorTooMany: "Số lượng file không được nhiều hơn",
      errorGeneric: "Không thể upload file"
    }
  },
  verificationCodeModal: {
    title: "Xác thực mã",
    description: "Vui lòng nhập mã xác thực được gửi trong email mời của bạn",
    buttonText: "Xác nhận",
    verifying: "Đang xác thực...",
    hint: "Mã xác thực bảo mật — vui lòng không chia sẻ với người khác.",
  },
};

// {
//     layout: {
//         "vi-VN": {
//             title: "Layout",
//             content: "Layout content",
//         },
//         "en-US": {
//             title: "Layout",
//             content: "Layout content",
//         }
//     }X-LANGUAGE
// }
